import { BASE_URL } from "../../Environment/config"
import { httpClient } from "../../Http/client";

export const registerUser = async (data) => {
    const url = `${BASE_URL}/signup`;

    const { data: registerData} = await httpClient.post(url, data);
    return registerData;
}